import { ReactElement } from "react";

export default function NewIndicator(): ReactElement {
  return (
    <div className="absolute -top-3 -left-3 h-10 w-10 text-sm text-white font-bold bg-fresh-mint rounded-full flex items-center justify-center">
      Nytt
    </div>
  );
}
